import { FieldSwitch, FlexBox, Text } from '@dixa/lib-shared-habla';

import { ElevioIntegrationState } from '../../../../../../../../messengerSettings.types';

type Props = {
  state: ElevioIntegrationState;
  onToggle: () => void;
};

/**
 * Elevio integration state description component. When elevio is connected
 * shows a toggle to enable / disable elevio integration.
 */
export function ElevioStateDescription({
  state,
  onToggle,
}: Props): JSX.Element {
  if (state.type === 'not-connected') {
    return (
      <Text.Paragraph>
        Connect your Elevio account to enable users to search and find answers
        in articles.
      </Text.Paragraph>
    );
  }

  return (
    <FlexBox justifyContent="space-between">
      <Text.Paragraph>
        Show Elevio integration interface on Messenger.
      </Text.Paragraph>
      <FieldSwitch
        input={{
          checked: state.enabled,
          name: 'active',
          value: 'active',
          onChange: onToggle,
        }}
      />
    </FlexBox>
  );
}
